import React, { Component } from 'react'
import '../../ui-elements/alerts/Index'
import { isMobileDevice } from '../../functions'
import { v4 as uuidv4 } from 'uuid'
import imgSiteMsgMaintenance from '../assets/icon_site_msg_maintenance.png'

class SiteMessages extends Component {
  constructor (props) {
    super(props)

    /* eslint-disable spellcheck/spell-checker */
    this.defaultTitles = [
      {
        lang: 'en',
        siteMessages: {
          alert: 'Alert',
          announcement: 'Announcement',
          information: 'Information',
          maintenance: 'Maintenance'
        }
      },
      {
        lang: 'de',
        siteMessages: {
          alert: 'Warnen',
          announcement: 'Ankündigung',
          information: 'Information',
          maintenance: 'Instandhaltung'
        }
      },
      {
        lang: 'es',
        siteMessages: {
          alert: 'Alerta',
          announcement: 'Anuncio',
          information: 'Información',
          maintenance: 'Mantenimiento'
        }
      },
      {
        lang: 'pt',
        siteMessages: {
          alert: 'Alerta',
          announcement: 'Anúncio',
          information: 'Em formação',
          maintenance: 'Manutenção'
        }
      },
      {
        lang: 'tr',
        siteMessages: {
          alert: 'Uyarmak',
          announcement: 'Duyuru',
          information: 'Bilgi',
          maintenance: 'Bakım'
        }
      },
      {
        lang: 'fr',
        siteMessages: {
          alert: 'Alerte',
          announcement: 'Annonce',
          information: 'Information',
          maintenance: 'Entretien'
        }
      },
      {
        lang: 'ja',
        siteMessages: {
          alert: 'Alert',
          announcement: 'Announcement',
          information: 'Information',
          maintenance: 'Maintenance'
        }
      },
      {
        lang: 'ch',
        siteMessages: {
          alert: 'Alert',
          announcement: 'Announcement',
          information: 'Information',
          maintenance: 'Maintenance'
        }
      }
    ]
    /* eslint-enable spellcheck/spell-checker */
  }

  getDefaultTitleByLanguage = (msgTypeCode, languageCode) => {
    const langTitles = this.defaultTitles.filter(item => item.lang === languageCode)[0]
    const siteMessages = langTitles.siteMessages
    let result = ''

    switch (msgTypeCode) {
      case 'ALERT':
        result = siteMessages.alert
        break
      case 'ANNOUNCEMENT':
        result = siteMessages.announcement
        break
      case 'INFO':
        result = siteMessages.information
        break
      case 'MAINT':
        result = siteMessages.maintenance
        break
      default:
        break
    }

    return result
  }

  handleSinglePopupContent = (msg, index) => {
    return (
      <div className={`site-msg-content site-msg-${msg.siteMessageType.code.toLowerCase()}`}>
        <div
          className='site-msg-modal-close'
          onClick={() => {
            const siteMsgModal = document.getElementById(`siteMsgModal${index}`)
            siteMsgModal.style.display = 'none'
            const groupWrapper = document.getElementById('siteMsgModalGroupWrapper')
            if (groupWrapper !== null) {
              const siteMsgNodes = groupWrapper.childNodes
              let i = 0
              const siteMsgArray = []
              while (i < siteMsgNodes.length) {
                const node = siteMsgNodes[i++]
                if (node.style.display !== 'none') {
                  siteMsgArray.push(node)
                }
              }
              if (siteMsgArray.length <= 0) {
                const screenWrapper = document.getElementById('siteMsgModalScreenWrapper')
                groupWrapper.remove()
                screenWrapper.remove()
              }
            }
          }}
        >&times;
        </div>
        {this.handleSiteMsgContentDetail(msg, true)}
      </div>
    )
  }

  handleSiteMsgContentDetail = (msg, isPopup) => {
    const messageTitle = this.getMessageTitleByLanguage(msg)

    return (
      <div
        key={`siteMessage${uuidv4()}`}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: (isPopup ? '95%' : '100%'),
          paddingTop: '5px',
          minHeight: '60px'
        }}
      >
        {messageTitle != null && messageTitle.length > 0
          ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center'
            }}
            >
              <div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                >
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          {msg.showIcon === 'Y' ? (
                            <td style={{ paddingBottom: '5px' }}>
                              {this.getMessageIcon(msg)}
                            </td>)
                            : null}
                          <td style={{ paddingLeft: '10px' }}>
                            <span
                              style={{ fontSize: '24px', fontWeight: 'bold' }}
                            >{messageTitle}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {this.getMessageTextByLanguage(msg)}
            </div>
          )
          : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {msg.showIcon === 'Y' ? (
                <table>
                  <tbody>
                    <tr>
                      {msg.showIcon === 'Y' ? (
                        <td style={{ paddingBottom: '5px' }}>
                          {this.getMessageIcon(msg)}
                        </td>)
                        : null}
                      <td style={{ paddingLeft: '10px' }}>
                        {this.getMessageTextByLanguage(msg)}
                      </td>
                    </tr>
                  </tbody>
                </table>)
                : this.getMessageTextByLanguage(msg)}
            </div>)}
      </div>)
  }

  getMessageTitleByLanguage = msg => {
    let result = msg.title
    let translationLanguageCode = msg.siteLanguage.code

    if (msg.translations && msg.translations.length > 0) {
      const translation = msg.translations.filter(tr => tr.siteLanguage.code === this.props.sessionLanguage)

      if (translation && translation.length > 0) {
        result = translation[0].titleTranslation
        translationLanguageCode = translation[0].siteLanguage.code
      }
    }

    if (result === '[DEFAULT]') {
      result = this.getDefaultTitleByLanguage(msg.siteMessageType.code, translationLanguageCode)
    }

    return result
  }

  getMessageIcon = msg => {
    switch (msg.siteMessageType.code) {
      case 'ALERT':
        return (
          <span
            style={{ color: '#FF3737', fontSize: '28px', padding: '7px 0px 0px 5px' }}
            className='fa fa-exclamation-triangle fa-lg'
          />
        )
      case 'ANNOUNCEMENT':
        return (
          <span
            style={{ color: 'white', fontSize: '28px', padding: '5px 0px 0px 5px' }}
            className='fa fa-bullhorn fa-lg'
          />
        )
      case 'INFO':
        return (
          <span
            style={{ color: 'black', fontSize: '40px', padding: '7px 0px 0px 0px' }}
            className='fa fa-info-circle fa-lg'
          />
        )
      case 'MAINT':
        return (
          <img src={imgSiteMsgMaintenance} alt='Message type icon' width='24px' />
        )
      default:
        break
    }

    return null
  }

  getMessageTextByLanguage = msg => {
    let result = decodeURIComponent(msg.message)

    if (msg.translations && msg.translations.length > 0) {
      const translation = msg.translations.filter(tr => tr.siteLanguage.code === this.props.sessionLanguage)

      if (translation && translation.length > 0) {
        result = decodeURIComponent(translation[0].messageTranslation)
      }
    }

    // Handle link
    let linkUrl = ''
    let linkText = ''
    let linkColor = '#222222'

    switch (msg.siteMessageType.type) {
      case 'Announcement':
        linkColor = 'white'
        break
      case 'Alert':
        linkColor = 'red'
        break
      default:
        break
    }

    const rawMessage = result
    let messagePrefix = rawMessage
    let messageSuffix = ''

    var linkPosition = result.indexOf('[Link|')
    if (linkPosition >= 0) {
      if (linkPosition === 0) {
        messagePrefix = ''
      } else {
        messagePrefix = result.substring(0, linkPosition - 1)
        result = result.substring(linkPosition + '[[Link|'.length - 1)
        const linkEndPosition = result.indexOf(']]')
        if (linkEndPosition < 0) {
          messagePrefix = rawMessage
        } else {
          const linkString = result.substring(0, linkEndPosition)
          const linkArray = linkString.split('|')
          if (linkArray.length !== 2) {
            messagePrefix = rawMessage
          } else {
            linkUrl = linkArray[0]
            linkText = linkArray[1]

            if (linkEndPosition < result.length) {
              messageSuffix = result.substring(linkEndPosition + ']]'.length)
            }
          }
        }
      }
    }

    return (
      <div style={{
        whiteSpace: 'pre-line'
      }}
      >
        {linkUrl === '' ? (
          <div>{rawMessage}
          </div>
        )
          : (
            <div>
              <span>{messagePrefix}</span>
              <a data-tag='track-link' data-analytics-text={linkText} href={linkUrl} style={{ color: (linkColor) }} target='_blank' rel='noopener noreferrer'>{linkText}</a>
              <span>{messageSuffix}</span>
            </div>
          )}
      </div>
    )
  }

  render () {
    let siteMessagesEmbedded = []
    let siteMessagesPopup = []

    if (isMobileDevice()) {
      // No popup in mobile
      siteMessagesEmbedded = this.props.messageItems
    } else {
      siteMessagesEmbedded = this.props.messageItems
        .filter(msg => msg.siteMessageAppearance.code === 'EMBEDDED')

      siteMessagesPopup = this.props.messageItems
        .filter(msg => msg.siteMessageAppearance.code === 'POPUP')
    }

    return (
      <div>
        {siteMessagesPopup.length <= 0 ? null : (
          <div
            id='siteMsgModalScreenWrapper'
            className='site-msg-modal-screen-wrapper'
          >
            <div
              id='siteMsgModalGroupWrapper'
              className='site-msg-modal-group-wrapper'
              style={{ backgroundColor: (siteMessagesPopup.length > 1 ? 'white' : '') }}
            >
              {siteMessagesPopup.map((msg, index) =>
                <div
                  key={`siteMsgModal${uuidv4()}`}
                  id={`siteMsgModal${index}`}
                  className='site-msg-modal'
                >
                  {this.handleSinglePopupContent(msg, index)}
                </div>)}
            </div>
          </div>)}
        {siteMessagesEmbedded.length <= 0 ? null : (
          <div className='row'>
            <div className='col-12'>
              {
                siteMessagesEmbedded.map((msg, index) =>
                  <div
                    key={`siteMsgEmbedded${uuidv4()}`}
                    className={`site-msg-content site-msg-${msg.siteMessageType.code.toLowerCase()}`}
                    style={{
                      marginTop: (index === 0 ? (isMobileDevice() ? '0px' : '10px') : ''),
                      borderBottom: '1px solid #fff'
                    }}
                  >
                    {this.handleSiteMsgContentDetail(msg, false)}
                  </div>
                )
              }
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default SiteMessages



// WEBPACK FOOTER //
// ./src/mi-app/siteMessages/SiteMessages.js